import { memo, useState } from 'preact/compat';

import { useLogin, useUiEvent, useWidgetContext, useWidgetState } from '../../hooks';
import { isMobile } from '../../lib/Media';

function getNotificationsType() {
	return isMobile() ? 'inside' : 'outside';
}

export const Badge = memo(function Badge() {
	const state = useWidgetState();
	const { props } = useWidgetContext();
	const { initialized } = useLogin();
	const [notifications, setNotifications] = useState(getNotificationsType());
	const links = Array.isArray(state?.links)
		? state.links
		: props?.service?.loginCfg?.links ?? [];

	useUiEvent(
		'resize',
		payload => {
			if (!initialized) {
				return;
			}

			if (payload.resize.delta.width === 0) {
				return;
			}

			setNotifications(getNotificationsType());
		},
		[initialized]
	);

	return (
		<div
			id='ribbon-badge'
			className='ribbon-badge'
			aria-label='Osobní navigace, přihlášení a další služby'
		>
			{initialized && (
				<szn-login-widget debug={props.debug} notifications={notifications}>
					{links.length ? (
						<ul>
							{links.map(({ href, text }) => (
								<li key={`${href}${text}`}>
									<a href={href}>{text}</a>
								</li>
							))}
						</ul>
					) : null}
				</szn-login-widget>
			)}
		</div>
	);
});
